import type { DeleteUserGroupsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

type DeleteUserGroupsInput = {
  UserGroupIds: string[];
};

const mapTrpcResponseToGraphQL = (trpcData: {
  deletedCount: number;
}): DeleteUserGroupsMutation => ({
  deleteUserGroups: {
    __typename: 'GenericMutationOutput',
    affected_rows: trpcData.deletedCount,
  },
});

export const useDeleteUserGroupsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.userGroup.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.userGroup.userGroupsWithApprovers.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.userGroup.userGroupById.queryKey(),
        });
      },
    }),
  });

  return {
    deleteUserGroups: async (
      variables: DeleteUserGroupsInput
    ): Promise<DeleteUserGroupsMutation> => {
      const result = await mutation.mutateAsync({
        Ids: variables.UserGroupIds,
      });

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
